// extracted by mini-css-extract-plugin
export var button = "_nz-2";
export var card = "_nz-0";
export var closeButtonContainer = "_nz-3";
export var iconContainer = "_nz-1";